import { getGoogleGeoCode, getIpLocation } from "@/actions/location.action";
import type { UserLocation } from "@/lib/geo-location/types";

const resolveLocationFromCoordinates = async (
	lat: number,
	lng: number,
): Promise<UserLocation> => {
	const googleLocation = await getGoogleGeoCode(lat, lng);

	if (googleLocation?.city) {
		return {
			...googleLocation,
			lat,
			lng,
		};
	}

	const ipLocation = await getIpLocation();

	return {
		...ipLocation,
		lat,
		lng,
	};
};

export const fetchUserLocation = async (): Promise<UserLocation> => {
	if (typeof navigator === "undefined" || !navigator.geolocation) {
		return getIpLocation();
	}

	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			async (pos) => {
				try {
					resolve(
						await resolveLocationFromCoordinates(
							pos.coords.latitude,
							pos.coords.longitude,
						),
					);
				} catch (error) {
					reject(error);
				}
			},
			async () => {
				try {
					resolve(await getIpLocation());
				} catch (error) {
					reject(error);
				}
			},
			{
				enableHighAccuracy: true,
				timeout: 10000,
				maximumAge: 300000,
			},
		);
	});
};
